import api from '../../../services/Api';
import { IAuditoriaServicosTerceirosPfResultado } from '../interfaces/IAuditoriaServicosTerceirosPf';

export const AuditoriaServicosTerceirosPfService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaServicosTerceirosPfResultado> {
    const response = await api.get<IAuditoriaServicosTerceirosPfResultado>('auditoria-servicos-terceiros-pf/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        totalPendentes: 0,
        totalLancamentosAnalisados: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoContabil: '',
        fundamentacaoFiscal: '',
        orientacaoJustificativa: '',
        lancamentosServicosTerceirosPf: [],
      }
    );
  },
};
